jQuery(document).ready(function() {
	// load slider for Headslider

jQuery('.tippslider').slick({
    dots: true,
    infinite: true,
    speed: 1000,
    slidesToShow: 1,
    arrows: true,
    adaptiveHeight: true
});

jQuery('' +
    '<?xml version="1.0" encoding="utf-8"?>\n' +
    '<!-- Generator: Adobe Illustrator 26.4.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n' +
    '<svg version="1.1" id="Ebene_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"\n' +
    '\t viewBox="0 0 33.5 64" style="enable-background:new 0 0 33.5 64;" xml:space="preserve">\n' +
    '<style type="text/css">\n' +
    '\t.st0{clip-path:url(#SVGID_00000170977703152091897680000006457137653247743657_);fill:none;stroke:#FFFFFF;stroke-width:0.5;}\n' +
    '</style>\n' +
    '<g>\n' +
    '\t<defs>\n' +
    '\t\t<rect id="SVGID_1_" x="0.9" y="1.3" width="31.6" height="61.8"/>\n' +
    '\t</defs>\n' +
    '\t<clipPath id="SVGID_00000023278362988412396980000009877334755506383536_">\n' +
    '\t\t<use xlink:href="#SVGID_1_"  style="overflow:visible;"/>\n' +
    '\t</clipPath>\n' +
    '\t\n' +
    '\t\t<polyline style="clip-path:url(#SVGID_00000023278362988412396980000009877334755506383536_);fill:none;stroke:#FFFFFF;stroke-width:0.5;" points="\n' +
    '\t\t31.8,1.5 1.3,32 32.3,62.9 \t"/>\n' +
    '</g>\n' +
    '</svg>\n'
).appendTo( ".slick-next ,.slick-prev");

    jQuery('<?xml version="1.0" encoding="utf-8"?> <svg version="1.1" id="Ebene_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"viewBox="0 0 12 6.6" style="enable-background:new 0 0 12 6.6;" xml:space="preserve"> <polygon  points="8.5,0.6 8.5,2.6 0.9,2.6 0.9,4 8.5,4 8.5,5.9 11.2,3.3 "/><line x1="-34.3" y1="-10.1" x2="-34.3" y2="-0.9"/></svg>').appendTo( ".button");







});

